type AdminIconProps = {
  name: string
  size?: number
  className?: string
}

const paths: Record<string, React.ReactNode> = {
  dashboard: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="3" width="7" height="7" rx="2" />
      <rect x="3" y="14" width="7" height="7" rx="2" />
      <rect x="14" y="14" width="7" height="7" rx="2" />
    </>
  ),

  book: (
    <>
      <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H11v16H6.5A2.5 2.5 0 0 0 4 21.5z" />
      <path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H13v16h4.5a2.5 2.5 0 0 1 2.5 2.5z" />
    </>
  ),

  modules: (
    <>
      <rect x="3" y="4" width="18" height="5" rx="2" />
      <rect x="3" y="15" width="18" height="5" rx="2" />
    </>
  ),

  paths: (
    <>
      <circle cx="6" cy="18" r="2" />
      <circle cx="18" cy="6" r="2" />
      <path d="M8 18c6 0 2-12 8-12" />
    </>
  ),

  roadmap: (
    <>
      <path d="M6 3v18" />
      <path d="M18 3v18" />
      <path d="M6 7h12" />
      <path d="M6 17h12" />
    </>
  ),

  server: (
    <>
      <rect x="3" y="4" width="18" height="6" rx="2" />
      <rect x="3" y="14" width="18" height="6" rx="2" />
      <path d="M7 7h.01M7 17h.01" />
    </>
  ),

  flag: (
    <>
      <path d="M5 21V4" />
      <path d="M5 4h11l-2 4 2 4H5" />
    </>
  ),

  content: (
    <>
      <path d="M5 4h14v16H5z" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </>
  ),

  article: (
    <>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M14 3v5h5" />
      <path d="M9 12h6M9 16h6" />
    </>
  ),

  userArticle: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-4 2.5-6 6-6" />
      <path d="M15 13h6M18 10v6" />
    </>
  ),

  posts: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M8 9h8M8 13h8M8 17h5" />
    </>
  ),

  stories: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m10 8 6 4-6 4z" />
    </>
  ),

  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-4 2.5-6 6-6s6 2 6 6" />
      <path d="M16 5a3 3 0 0 1 0 6" />
      <path d="M17 14c2.5.5 4 2.5 4 5" />
    </>
  ),

  community: (
    <>
      <circle cx="8" cy="9" r="3" />
      <circle cx="17" cy="9" r="3" />
      <path d="M2 20c0-4 2-6 6-6s6 2 6 6" />
      <path d="M14 15c1-.7 2-.9 3-.9 3 0 5 2 5 5.9" />
    </>
  ),

  reviews: (
    <>
      <path d="M4 5h16v12H8l-4 4z" />
      <path d="M8 9h8M8 13h5" />
    </>
  ),

  heart: (
    <path d="M20.8 5.7a5.5 5.5 0 0 0-7.8 0L12 6.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 22l8.8-8.5a5.5 5.5 0 0 0 0-7.8z" />
  ),

  store: (
    <>
      <path d="M4 9h16l-1-5H5z" />
      <path d="M5 9v11h14V9" />
      <path d="M9 20v-6h6v6" />
    </>
  ),

  package: (
    <>
      <path d="m4 7 8-4 8 4-8 4z" />
      <path d="M4 7v10l8 4 8-4V7" />
      <path d="M12 11v10" />
    </>
  ),

  orders: (
    <>
      <path d="M6 3h12v18H6z" />
      <path d="M9 8h6M9 12h6M9 16h4" />
    </>
  ),

  truck: (
    <>
      <path d="M3 6h11v10H3z" />
      <path d="M14 10h4l3 3v3h-7z" />
      <circle cx="7" cy="18" r="2" />
      <circle cx="18" cy="18" r="2" />
    </>
  ),

  ticket: (
    <>
      <path d="M4 7h16v4a2 2 0 0 0 0 4v4H4v-4a2 2 0 0 0 0-4z" />
      <path d="M12 7v12" />
    </>
  ),

  wallet: (
    <>
      <path d="M4 6h14a2 2 0 0 1 2 2v11H4a2 2 0 0 1-2-2V6z" />
      <path d="M16 11h6v5h-6a2.5 2.5 0 0 1 0-5z" />
    </>
  ),

  cart: (
    <>
      <path d="M3 4h2l2 11h10l3-8H6" />
      <circle cx="9" cy="19" r="1.5" />
      <circle cx="17" cy="19" r="1.5" />
    </>
  ),

  bundle: (
    <>
      <rect x="4" y="7" width="16" height="14" rx="2" />
      <path d="M12 7v14M3 7h18" />
      <path d="M8 3c2 0 4 4 4 4S6 7 6 5c0-1.1.9-2 2-2z" />
      <path d="M16 3c-2 0-4 4-4 4s6 0 6-2c0-1.1-.9-2-2-2z" />
    </>
  ),

  sale: (
    <>
      <path d="M5 5h14v14H5z" />
      <path d="m8 16 8-8" />
      <circle cx="9" cy="9" r="1" />
      <circle cx="15" cy="15" r="1" />
    </>
  ),

  award: (
    <>
      <circle cx="12" cy="9" r="6" />
      <path d="m8 14-2 7 6-3 6 3-2-7" />
    </>
  ),

  border: (
    <>
      <path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5" />
    </>
  ),

  activity: (
    <path d="M3 12h4l2-7 4 14 2-7h6" />
  ),

  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 10h18" />
    </>
  ),

  chart: (
    <>
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </>
  ),

  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1a7 7 0 0 0-1.7-1L14.5 3h-5l-.4 3.1a7 7 0 0 0-1.7 1L5 6.1 3 9.5 5.1 11a7 7 0 0 0 0 2L3 14.5 5 18l2.4-1.1a7 7 0 0 0 1.7 1l.4 3.1h5l.4-3.1a7 7 0 0 0 1.7-1L19 18l2-3.5-2.1-1.5a7 7 0 0 0 .1-1z" />
    </>
  ),

  update: (
    <>
      <path d="M20 7v5h-5" />
      <path d="M4 17v-5h5" />
      <path d="M6.1 8A7 7 0 0 1 18 6l2 2" />
      <path d="M17.9 16A7 7 0 0 1 6 18l-2-2" />
    </>
  ),

  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-4-4" />
    </>
  ),

  menu: (
    <path d="M4 7h16M4 12h16M4 17h16" />
  ),

  close: (
    <path d="m6 6 12 12M18 6 6 18" />
  ),

  chevron: (
    <path d="m9 18 6-6-6-6" />
  ),

  external: (
    <>
      <path d="M14 4h6v6" />
      <path d="m20 4-9 9" />
      <path d="M18 13v7H4V6h7" />
    </>
  ),

  home: (
    <>
      <path d="m3 11 9-8 9 8" />
      <path d="M5 10v11h14V10M9 21v-7h6v7" />
    </>
  ),

  logout: (
    <>
      <path d="M10 17l5-5-5-5" />
      <path d="M15 12H3" />
      <path d="M15 4h5v16h-5" />
    </>
  ),
}

export function AdminIcon({
  name,
  size = 20,
  className,
}: AdminIconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name] ?? paths.settings}
    </svg>
  )
}
